
import React, { useEffect } from "react";
import '@fortawesome/fontawesome-free/css/all.min.css';
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./components/Home/Home.jsx";
import Login from "./components/Login/Login.jsx";
import TranslateFile from "./components/Translatefile/Translatefile.jsx";
import PreviewFile from "./components/Previewfile/Previewfile.jsx";
import NotFound from "./components/NotFound/NotFound.jsx";


function App() {


  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/home" element={<Home />} />
        <Route path="/translatefile" element={<TranslateFile />} />
        <Route path="/previewfile" element={<PreviewFile />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;